export const defaultQuizDetails = {
    quizName:"",
    duration: null,
    dueDate:""
  };